import { createFileRoute } from "@tanstack/react-router";
import { StandardDetailPage } from "@/components/admin/standards/StandardDetailPage";

export const Route = createFileRoute(
  "/$workspaceSlug/admin/standards/$standardId",
)({
  component: StandardDetailPage,
});
